import { CheckCircle2, Circle, CalendarDays } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { fmtDay } from "@/lib/daytime";

const STATUS_CLS = { active: "bg-emerald-100 text-emerald-700", frozen: "bg-sky-100 text-sky-700", expired: "bg-slate-200 text-slate-500", cancelled: "bg-red-100 text-red-600" };

export function VisitDots({ total, used }) {
  return (
    <div className="flex flex-wrap gap-1.5 mt-2" data-testid="pass-dots">
      {Array.from({ length: total }).map((_, i) => i < used
        ? <CheckCircle2 key={i} className="w-6 h-6 text-turquoise" data-testid="pass-dot-used" />
        : <Circle key={i} className="w-6 h-6 text-gold fill-gold/30" data-testid="pass-dot-open" />)}
    </div>
  );
}

export function PassCard({ p, onBook }) {
  const rock = p.visits_total > 0;
  return (
    <div className="bg-navy text-white rounded-3xl p-5 relative overflow-hidden" data-testid={`daytime-pass-${p.id}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-[11px] tracking-[0.2em] font-bold text-turquoise">{rock ? "ROCK PASS" : p.kind === "family" ? "FAMILY ROCK MEMBERSHIP" : "ACTIVE MEMBERSHIP"}</p>
          <p className="font-display font-extrabold text-lg">{p.label}</p>
        </div>
        <div className="flex flex-col items-end gap-1">
          <Badge className={`${STATUS_CLS[p.effective_status] || ""} capitalize`} data-testid="pass-status">{p.effective_status}</Badge>
          {!p.paid && p.effective_status === "active" && <Badge className="bg-coral text-white" data-testid="pass-unpaid">Unpaid</Badge>}
        </div>
      </div>
      {p.explorers.length > 0 && <p className="text-sm text-white/70 mt-1">Explorer{p.explorers.length > 1 ? "s" : ""}: {p.explorers.map((e) => e.name).join(" & ")}</p>}
      {rock && <>
        <VisitDots total={p.visits_total} used={p.visits_used} />
        <p className="font-display font-bold text-gold mt-2" data-testid="pass-visits-remaining">{p.visits_remaining} Visit{p.visits_remaining === 1 ? "" : "s"} Remaining{p.reserved ? ` · ${p.reserved} booked` : ""}</p>
      </>}
      <p className="text-xs text-white/60 mt-2 flex items-center gap-1" data-testid="pass-valid"><CalendarDays className="w-3.5 h-3.5" /> Valid {fmtDay(p.start)} – {fmtDay(p.end)}{p.upcoming ? ` · ${p.upcoming} upcoming` : ""}</p>
      {p.founding && p.paid && p.badge_token && <a href={`/support/founding-badge/${p.badge_token}`} className="mt-3 mr-2 inline-block text-sm font-bold border border-gold text-gold rounded-full px-4 py-2" data-testid={`pass-founding-badge-${p.id}`}>MY FOUNDING BADGE</a>}
      {p.effective_status === "active" && <button onClick={onBook} className="mt-3 text-sm font-bold bg-gold text-navy rounded-full px-4 py-2" data-testid={`pass-book-more-${p.id}`}>BOOK MORE DAYS</button>}
    </div>
  );
}
